export default __webpack_public_path__ + "static/media/scriptura.2eadf4de.jpg";